export const parentColumnGroups = [
    { label: "Scheme Info", span: 3, }, // width: "280px" },
    { label: "pNAV Rank", span: 2, },   // width: "110px"  },
    { label: "CAGR %", span: 1, },     //width: "110px" },
    { label: "% Change", span: 2, },   //width: "100px" },
    { label: "Annualized Returns", span: 2, }  // width: "100px" }
];

export const pcTableDisplayColumns = [
    { field: "scheme_name", label: 'Scheme Name', label2: 'Scheme Name', width: "150px",
              tooltip: "", sortable: false, parent: true, child: true, JStype: "string",},
    { field: "launch_date", label: 'Launch Date', label2: 'Launch Date', width: "50px",
              tooltip: "", sortable: false, parent: true, child: true, JStype: "Date",},
    { field: "scheme_stability", label: 'Scheme Stability', label2: 'Scheme Stability',
              width: "60px", tooltip: "Based number of Years and Assets under Management",
              sortable: false, parent: true, child: true, JStype: "string",},
    { field: "pNAV_best_rank", label: 'Best', label2: 'pNAV Rank - Best', width: "50px",
              tooltip: "Higher Rank of Scheme based on predicted performance in last 2 months",
              sortable: false, parent: true, child: true, JStype: "number", },
    { field: "pNAV_worst_rank", label: 'Worst', label2: 'pNAV Rank - Worst', width: "50px",
              tooltip: "Lower Rank of Scheme based on predicted performance in last 2 months",
              sortable: false, parent: true, child: true, JStype: "number", },
    { field: 'cagr_percentage_as_of_last_actual', label: 'as of Last Actual', 
              label2: 'CAGR % as of Last Actual', width: "60px",
              tooltip: "", sortable: true, parent: true, child: true, JStype: "number", },
    { field: "percent_change_in_7_days", label: 'in 7 Days', label2: '% Change in 7 Days',
              width: "40px", tooltip: "", sortable: false, parent: true, child: true,
              JStype: "number", },
    { field: "percent_change_in_30_days", label: 'in 30 Days', label2: '% Change in 30 Days',
              width: "40px", tooltip: "", sortable: false, parent: true, child: true,
              JStype: "number", },
    { field: "percent_change_in_180_days", label: 'in 180 Days', label2: '% Change in 180 Days',
              width: "40px", tooltip: "", sortable: false, parent: true, child: true,
              JStype: "number", },
    { field: 'annualized_returns_in_last_1_year', label: 'last 1 year',
              label2: 'Annualized Returns last 1 year', width: "40px",
              tooltip: "", sortable: false, parent: true, child: true, JStype: "number", },    
    { field: 'annualized_returns_in_last_3_year', label: 'last 3 year',
              label2: 'Annualized Returns last 3 year', width: "40px",
              tooltip: "", sortable: false, parent: true, child: true, JStype: "number", },    
  ];
export const parentColumns = [ 
    { field: "scheme_name", label: 'Scheme Name', label2: 'Scheme Name', width: "150px",
              tooltip: "", sortable: true,},
    { field: "launch_date", label: 'Launch Date', label2: 'Launch Date', width: "50px",
              tooltip: "", sortable: false,},
    { field: "scheme_stability", label: 'Scheme Stability', label2: 'Scheme Stability',
              width: "60px", tooltip: "Based on - Scheme Launch Date (Age) and AUM",
              sortable: false,},
    { field: "pNAV_best_rank", label: 'Best', label2: 'pNAV Rank - Best', width: "40px",
              tooltip: "Higher Rank of the Scheme - based on pNAV based evaluation in last 2 months",
              sortable: false,},
    { field: "pNAV_worst_rank", label: 'Worst', label2: 'pNAV Rank - Worst', width: "40px",
              tooltip: "Lower Rank of the Scheme - based on pNAV based evaluation in last 2 months",
              sortable: false,},
    { field: 'cagr_percentage_as_of_last_actual', label: 'as of Last Actual',
              label2: 'CAGR % as of Last Actual', width: "60px", tooltip: "", sortable: true,},
    { field: "percent_change_in_7_days", label: 'in 7 Days', label2: '% Change in 7 Days', 
              width: "40px", tooltip: "", sortable: true,},
    { field: "percent_change_in_30_days", label: 'in 30 Days', label2: '% Change in 30 Days', 
              width: "40px", tooltip: "", sortable: true,},
    { field: "percent_change_in_180_days", label: 'in 180 Days', label2: '% Change in 180 Days',
              width: "40px", tooltip: "", sortable: true,},
    { field: 'annualized_returns_in_last_1_year', label: 'last 1 year',
              label2: 'Annualized Returns last 1 year',  width: "40px", tooltip: "",
              sortable: true,},
    { field: 'annualized_returns_in_last_3_year', label: 'last 3 year',
              label2: 'Annualized Returns last 3 year', width: "40px", tooltip: "",
              sortable: true,},    
  ];
export const parentDetailsColumns = [ 
    { field: "scheme_name", label: 'Scheme Name' },
    { field: "nav_base_value_date", label: 'NAV base value Date' },
    { field: "last_known_actual_nav", label: 'Last Known Actual NAV' },
    { field: "last_known_actual_nav_date", label: 'Last Known Actual NAV Date' },
    { field: 'percent_change_in_90_days', label: '% Change in 90 Days' },
    { field: 'annualized_returns_in_last_5_year', label: 'Annualized returns in last 5 year' },

  ];
export const childColumns = [ 
    { field: "scheme_name", label: 'Scheme Name', label2: 'Scheme Name', width: "150px",
              tooltip: "", sortable: true, },
    { field: "launch_date", label: 'Launch Date', label2: 'Launch Date', width: "50px",
              tooltip: "", sortable: false, },
    { field: "scheme_stability", label: 'Scheme Stability', label2: 'Scheme Stability',
              width: "60px", tooltip: "Based on - Scheme Launch Date (Age) and AUM",
              sortable: false, },
    { field: "pNAV_best_rank", label: 'Best', label2: 'pNAV Rank - Best', width: "40px",
              tooltip: "Best Rank of the Scheme - based on pNAV based evaluation in last 2 months",
              sortable: false,},
    { field: "pNAV_worst_rank", label: 'Worst', label2: 'pNAV Rank - Worst', width: "40px",
              tooltip: "Lower Rank of the Scheme - based on pNAV based evaluation in last 2 months",
              sortable: false,},
    { field: 'cagr_percentage_as_of_last_actual', label: 'as of Last Actual',
              label2: 'CAGR % as of Last Actual', width: "60px", tooltip: "", sortable: true, },
    { field: "percent_change_in_7_days", label: 'in 7 Days', label2: '% Change in 7 Days',
              width: "40px", tooltip: "", sortable: true, },
    { field: "percent_change_in_30_days", label: 'in 30 Days', label2: '% Change in 30 Days',
              width: "40px", tooltip: "", sortable: true, },
    { field: "percent_change_in_180_days", label: 'in 180 Days', label2: '% Change in 180 Days',
              width: "40px", tooltip: "", sortable: true, },
    { field: 'annualized_returns_in_last_1_year', label: 'last 1 year',
              label2: 'Annualized Returns last 1 year',  width: "40px", tooltip: "",
              sortable: true,},
    { field: 'annualized_returns_in_last_3_year', label: 'last 3 year',
              label2: 'Annualized Returns last 3 year', width: "40px", tooltip: "",
              sortable: true, },    
  ];